import { useEffect, useState } from 'react';
import { Account, useAuth } from 'spindl-shared-components';
import { IS_DEV } from '../../lib/config';
import { mockAccount } from './fixtures';

const useGetAccount = (): {
  account?: Account
} => {
  const { account } = useAuth();
  const [accountPayload, setAccountPayload] = useState<Account | undefined>();

  useEffect(() => {
    setAccountPayload(IS_DEV ? mockAccount : account);
  }, [account]);

  return { account: accountPayload };
};

export default useGetAccount;